import { FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useActions, useSelector } from '~/hooks';
import { ApiHelperSelectInput, ApiHelperSelectInputWrapperProps } from './ApiHelperSelectInput';

export const SelectAssistantId: FC<ApiHelperSelectInputWrapperProps> = ({
  value,
  setValue,
  ...props
}) => {
  const { t } = useTranslation();

  const loadingAssistants = useSelector(({ entityStates }) => entityStates.assistants.loading);
  const assistantById = useSelector(({ workspaceResources }) => workspaceResources.assistants.byId);

  const { getAssistants } = useActions(({ assistantActions }) => ({
    getAssistants: assistantActions.listAssistants,
  }));

  const assistantItems = useMemo(
    () =>
      Object.entries(assistantById).map(([id, assistant]) => {
        return {
          label: assistant.name,
          value: id,
        };
      }),

    [assistantById],
  );

  useEffect(() => {
    getAssistants();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ApiHelperSelectInput
      label={t('chooseAssistant')}
      items={assistantItems}
      onChange={(value) => setValue('assistant_id', value)}
      loading={loadingAssistants}
      value={value}
      noItemsFound={t('noAssistants')}
      {...props}
    />
  );
};
